var _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllbridgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1100,
    viewBox: "0 0 1100 1100",
    width: 1100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 1100,
    rx: 550,
    width: 1100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m758.954 460.941-119.923-119.955h-181.7l-58.139 58.16v-207.197h-61.785v367.138 79.971l119.924 119.956h181.7l58.147-58.16v207.196h65.414v-345.328zm-148.997 236.277h-119.915l-87.221-87.24v-50.891-69.065l87.221-87.241h119.915l87.221 87.241v76.336 43.62z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.733 672.111v-330.756h-61.732v359.833l210.623 210.81h210.613v-61.79h-181.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.789 188v62.003h182.421l178.769 178.715v331.9h62.021v-361.078l-211.61-211.54z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllbridgeIcon);
export default __webpack_public_path__ + "static/media/allbridge-icon.7d3feb0e1e0f5dcbf636557c5fa496f6.svg";
export { ForwardRef as ReactComponent };